import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams, ModalController, Modal } from 'ionic-angular';

import { Reviews, Api,  Item, Dokumen  } from '@providers/asset/index';
import { LocationPage, DetailImagePage } from '../';


@Component({
  selector: 'page-detail-review',
  templateUrl: 'page.html'
})
export class DetailReviewPage {

  item:any=[];

  images:any=[];
  base_url='';
  url_img='';

  constructor(
    public navCtrl: NavController,
    public reviewApi: Reviews,
    public api : Api,
    public itemApi : Item,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public dokumenApi : Dokumen,
    public modalCtrl: ModalController,
    public navParams: NavParams
  ) {

    this.item = navParams.get('item');
    console.log(this.item);

    this.url_img = this.dokumenApi.file_url;
    this.base_url = this.api.url;
    
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){

  }

  viewImage(generated_name) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.url_img+this.item.generated_name
    });
    profileModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/detail_reviews/page.ts